module.exports = __webpack_public_path__ + "graphics/applePay.ckh.3e8ee7294f815ff41ab5727e0976af6f.svg";